  <div class='container'>
    <ul ngbNav class="nav-tabs" role="tablist" #nav="ngbNav">
      <li ngbNavItem class="nav-item">
          <a ngbNavLink (click)="NewUser()">New</a>
      <ng-template ngbNavContent>
            <form action='' id='newForm' ngNativeValidate>
          <div class='row topmargin-user-management'>
            <div class='col-sm-4 col-xs-4 centralign'>
                <label class='labelControl margintop floatright' >Email Address:</label>
            </div>
            <div class='col-sm-5 col-xs-5'>
                <input class='form-control input-lg' type='email' id='email' name='emailID' #email [(ngModel)]="emailID" (ngModelChange)="emailID = $event.toLowerCase()" (focusout)="checkEmail(email.value)"/>
            </div>
            <div class='col-sm-3 col-xs-3' *ngIf="emailcheck">
              <label class="validation">Enter valid Email Address</label>
          </div>
        </div>
        <div class='row'>
          <div class='col-sm-4 col-xs-4 centralign'>
              <label class='labelControl margintop floatright'>First Name:</label>
          </div>
          <div class='col-sm-5 col-xs-5'>
              <input class='form-control input-sm' type='text' name='firstName' #fname [(ngModel)]="firstNameUser" (focusout)="checkFname(fname.value)"/>
          </div>
          <div class='col-sm-3 col-xs-3' *ngIf="fnameCheck">
            <label class="validation">Enter valid First Name</label>
          </div>
      </div>
    <div class='row'>
      <div class='col-sm-4 col-xs-4 centralign'>
          <label class='labelControl margintop floatright'>Last Name:</label>
      </div>
      <div class='col-sm-5 col-xs-5'>
          <input class='form-control input-sm' type='text' name='lastName' #lname [(ngModel)]="lastNameUser" (focusout)="checkLname(lname.value)"/>
      </div>
      <div class='col-sm-3 col-xs-3' *ngIf="lnamecheck">
        <label class="validation">Enter valid Last Name</label>
      </div>
  </div>
  <div class='row'>
    <div class='col-sm-4 col-xs-4 centralign'>
        <label class='labelControl margintop floatright'>File Format:</label>
    </div>
    <div class='col-sm-5 col-xs-5 dropdown-div'>
      <select class='form-control input-sm dropdown form-select' name='fileFormatCreate' [(ngModel)]='fileFormat'>
        <option selected="selected" value="Standard">Standard</option>
      </select>
    </div>
  </div>
  <div class='row' *ngIf="authoritycheck">
    <div class='col-sm-4 col-xs-4 centralign'>
        <label class='labelControl margintop floatright'>Role:</label>
    </div>
    <div class='col-sm-5 col-xs-5 dropdown-div'>
      <select class='form-control input-sm dropdown form-select' name='roleCreate' [(ngModel)]='role'>
        <option  selected="selected" value="Standard">Standard</option>
        <option value="Administrator">Administrator</option>
      </select>
    </div>
  </div>
  <div class='row' *ngIf="authoritycheck">
    <div class='col-sm-4 col-xs-4 centralign'>
        <label class='labelControl margintop floatright'>Business partner:</label>
    </div>
    <div class='col-sm-5 col-xs-5 dropdown-div'>
      <select class='form-control input-sm dropdown form-select' name='businessPartnerCreate' [(ngModel)]='businessPartner'>
        <option class='option' *ngFor='let option of options' [ngValue]="option">{{option}}</option>
    </select>
    </div>
  </div>
  <div class='row'>
    <div class='col-sm-4 col-xs-4'>
    </div>
    <div class='col-sm-5 col-xs-5'>
    </div>
    <div class='col-sm-3 col-xs-3'>
      <button type='button' class='btn btn-primary btn-round margintop float-right-user' (click)='createAdmin(email.value,fname.value, lname.value)'>Create</button>
    </div>
  </div>

  </form>
        </ng-template>
      </li>
      <li ngbNavItem class="nav-item">
        <a ngbNavLink (click)="getAllUser()">Edit</a>
        <ng-template ngbNavContent>
          <form action='' id='newForm' ngNativeValidate *ngIf="editForm">
              <div class="form-group row marginRight topmargin">
                  <div class="col-sm-12 table-responsive margin-left-table">
                      <table class="table">
                          <thead>
                              <tr>
                                  <th>First name</th>
                                  <th>Last name</th>
                                  <th>User ID</th>
                                  <th *ngIf="authoritycheck">Role</th>
                                  <th>File format</th>
                                  <th>Business partner(s)</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let user of users; let i = index" (click)="setClickedRow(user,i)" [class.active]="i == selectedRow">
                                  <td>{{user.firstName}}</td>
                                  <td>{{user.lastName}}</td>
                                  <td>{{user.email}}</td>
                                  <td *ngIf="authoritycheck">{{user.authorities}}</td>
                                  <td class='capitalize'>{{(user.additionalInfo)!== null ? ((user.authorities) === 'Super Admin'? (user.additionalInfo).split(",")[0] : (user.additionalInfo).split(",")[1]) : " " }}</td>
                                  <td>{{(user.additionalInfo)!== null ? ((user.authorities) === 'Super Admin'? " " : (user.additionalInfo).split(",")[0]) :  " "}}</td>
                                 </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
              <div class="row">
                <div class="col-sm-4 paginationDiv edit-pagination" *ngIf="usersCount>10">
                        <ul class="pagination">
                                <li class="page-item" [class.disabled]="PreviousClick(pageNumber)"><a class="page-link" (click)="previousClickAction(pageNumber)">Previous</a></li>
                                <li class="page-item" *ngFor="let number of pageNumber; let i = index" [attr.data-index]="i"><a class="page-link" [ngClass]="{'active-anchor': number===returnPageNum()}" id="page-num-{{i+1}}" (click)="loadUsers($event,number)">{{number}}</a></li>
                                <li class="page-item" [class.disabled]="NextClick(pageNumber)"><a class="page-link" (click)="nextClickAction(pageNumber)">Next</a></li>
                              </ul>
                </div>

    </div>
              <div class="row">
                  <div class='col-sm-8 col-xs-8'></div>
                  <div class='col-sm-4 col-xs-4'>
                      <button type='button' class='btn btn-primary btn-round margintop float-right-user'  [disabled]='ifcheckedrow' (click)='editInfo()'>Edit</button>
                    </div>
              </div>
            </form>

            <form action='' id='updateForm' *ngIf="updateForm" ngNativeValidate>
              <div class='row topmargin-user-management'>
                <div class='col-sm-4 col-xs-4 centralign'>
                    <label class='labelControl margintop floatright'>Email Address:</label>
                </div>
                <div class='col-sm-5 col-xs-5'>
                    <input class='form-control input-lg' type='email' id='emailEdit' name='emailIdUserEdit'  #emailIdEdit [(ngModel)]="emailEdit" (focusout)="checkEmail(emailIdEdit.value)"   [disabled]='disableEmailFlag'/>
                </div>
                <div class='col-sm-3 col-xs-3' *ngIf="emailcheck">
                  <label class="validation">Enter valid Email Address</label>
              </div>
            </div>
            <div class='row'>
              <div class='col-sm-4 col-xs-4 centralign'>
                  <label class='labelControl margintop floatright' >First Name:</label>
              </div>
              <div class='col-sm-5 col-xs-5'>
                  <input class='form-control input-sm' type='text' name='firstNameEdit' #firstNameUserEdit [(ngModel)]="fnameEdit" (focusout)="checkFname(firstNameUserEdit.value)"/>
              </div>
              <div class='col-sm-3 col-xs-3' *ngIf="fnameCheck">
                <label class="validation">Enter valid First Name</label>
              </div>
          </div>
        <div class='row'>
          <div class='col-sm-4 col-xs-4 centralign'>
              <label class='labelControl margintop floatright'>Last Name:</label>
          </div>
          <div class='col-sm-5 col-xs-5'>
              <input class='form-control input-sm' type='text' name='lastNameEdit' #lastNameUserEdit [(ngModel)]="lnameEdit" (focusout)="checkLname(lastNameUserEdit.value)"/>
          </div>
          <div class='col-sm-3 col-xs-3' *ngIf="lnamecheck">
            <label class="validation">Enter valid Last Name</label>
          </div>
      </div>
      <div class='row'>
        <div class='col-sm-4 col-xs-4 centralign'>
            <label class='labelControl margintop floatright'>File Format:</label>
        </div>
        <div class='col-sm-5 col-xs-5 dropdown-div'>
          <select class='form-control input-sm dropdown' name='fileFormatEditName' [(ngModel)]='fileFormatEditUpdate'>
            <option value="Standard">Standard</option>
          </select>
        </div>
      </div>
      <div class='row' *ngIf="authoritycheck">
        <div class='col-sm-4 col-xs-4 centralign'>
            <label class='labelControl margintop floatright'>Role:</label>
        </div>
        <div class='col-sm-5 col-xs-5 dropdown-div'>
          <select class='form-control input-sm dropdown' name='roleEditName' [(ngModel)]='roleEdit'>
            <option value="Standard">Standard</option>
            <option value="Administrator">Administrator</option>
          </select>
        </div>
      </div>
      <div class='row' *ngIf="authoritycheck">
        <div class='col-sm-4 col-xs-4 centralign'>
            <label class='labelControl margintop floatright'>Business partner:</label>
        </div>
        <div class='col-sm-5 col-xs-5 dropdown-div'>
         <select class='form-control input-sm dropdown' name='businessPartnerEditName' required [(ngModel)]='businessPartnerEdit'>
            <option class='option' *ngFor='let option of options' [ngValue]="option" [selected]="option == 1">{{option}}</option>
        </select>
        </div>
      </div>
      <div class='row'>
        <div class='col-sm-4 col-xs-4'>
        </div>
        <div class='col-sm-5 col-xs-5'>
        </div>
        <div class='col-sm-3 col-xs-3'>
          <button type='button' class='btn btn-primary btn-round margintop float-right-user'
                  (click)='updateUserInfo(emailIdEdit.value,firstNameUserEdit.value, lastNameUserEdit.value, fileFormatEdit.value)'>Update</button>
        </div>
      </div>

      </form>
        </ng-template>
      </li>
      <li ngbNavItem class="nav-item">
        <a ngbNavLink (click)="getAllUser()">Delete</a>
        <ng-template ngbNavContent>
          <form action='' id='newForm'>
              <div class="form-group row marginRight topmargin table-row">
                  <div class="col-sm-12 table-responsive margin-left-table">
                      <table class="table">
                          <thead>
                              <tr>
                                  <th>First name</th>
                                  <th>Last name</th>
                                  <th>User ID</th>
                                  <th *ngIf="authoritycheck">Role</th>
                                  <th>File format</th>
                                  <th>Business partner(s)</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let user of users; let i = index" (click)="setClickedRowDelete(user,i)" [class.active]="i == selectedRow">
                                  <td>{{user.firstName}}</td>
                                  <td>{{user.lastName}}</td>
                                  <td>{{user.email}}</td>
                                  <td *ngIf="authoritycheck">{{user.authorities}}</td>
                                  <td class='capitalize'>{{(user.additionalInfo)!== null ? ((user.authorities) === 'Super Admin'? (user.additionalInfo).split(",")[0] : (user.additionalInfo).split(",")[1]) : " " }}</td>
                                  <td>{{(user.additionalInfo)!== null ? ((user.authorities) === 'Super Admin'? " " : (user.additionalInfo).split(",")[0]) :  " "}}</td>
                              </tr>
                          </tbody>

                      </table>
                  </div>
              </div>
              <div class="row">
                <div class="col-sm-4 paginationDiv edit-pagination" *ngIf="usersCount>10">
                        <ul class="pagination">
                                <li class="page-item" [class.disabled]="PreviousClick(pageNumber)"><a class="page-link" (click)="previousClickAction(pageNumber)">Previous</a></li>
                                <li class="page-item" *ngFor="let number of pageNumber; let i = index" [attr.data-index]="i"><a class="page-link" [ngClass]="{'active-anchor': number===returnPageNum()}" id="page-num-{{i+1}}" (click)="loadUsers($event,number)">{{number}}</a></li>
                                <li class="page-item" [class.disabled]="NextClick(pageNumber)"><a class="page-link" (click)="nextClickAction(pageNumber)">Next</a></li>
                              </ul>
                </div>

    </div>
              <div class="row">
                  <div class='col-sm-8 col-xs-8'></div>
                  <div class='col-sm-4 col-xs-4'>
                      <button type='button' class='btn btn-primary btn-round margintop float-right-user'  [disabled]='ifcheckedrowdelete' (click)='delete_user_info()'>Delete</button>

                     </div>
              </div>
            </form>



           </ng-template>
      </li>

    </ul>
    <div [ngbNavOutlet]="nav"></div>
    </div>
      <div class='footer footer-user-management'>
        <p class="padding-bottom">Allianz @copyright. All rights reserved</p>
      </div>
